import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SitePage, PageHead } from "./SiteChrome";
import { PLATFORMS } from "./siteData";

export default function PlatformsPage() {
  return (
    <SitePage testId="platforms-page">
      <PageHead
        label="The Ecosystem"
        title={<>Three platforms. <span className="grad-text">One adaptive intelligence.</span></>}
        lede="Purpose-built for clinical, medical, and revenue workflows — unified by ARIA, the adaptive AI engine powering every CamelionAI product."
      />
      <div className="sp-plat-list">
        {PLATFORMS.map((p) => (
          <div className={`sp-plat-row p-${p.variant}`} key={p.slug} data-testid={`platform-row-${p.slug}`}>
            <div className="pcard-icon-wrap"><p.icon size={24} /></div>
            <div className="sp-plat-body">
              <div className="pcard-name">{p.name}</div>
              <p className="sp-plat-sub">{p.tagline}</p>
              <p className="sp-plat-summary">{p.summary}</p>
              <div className="pcard-tags">
                {p.features.slice(0, 4).map((f) => <span key={f.t} className="pcard-tag">{f.t}</span>)}
              </div>
            </div>
            <div className="sp-plat-actions">
              <Link to={`/platforms/${p.slug}`} className="btn-primary sp-btn" data-testid={`platform-detail-link-${p.slug}`}>
                Learn more <ArrowRight size={15} />
              </Link>
              <a href={p.href} target="_blank" rel="noopener noreferrer" className="btn-glass sp-btn">
                Visit {p.name}
              </a>
            </div>
          </div>
        ))}
      </div>
      <div className="sp-cta-strip">
        <p>Every platform contributes intelligence to CamelionAI — and receives intelligence from it.</p>
        <Link to="/contact?type=beta" className="btn-primary sp-btn" data-testid="platforms-beta-cta">
          Get Beta Access <ArrowRight size={15} />
        </Link>
      </div>
    </SitePage>
  );
}
